/*
 * @Descripttion: 通用提示信息弹窗
 * @version:
 * @Author: xutingting
 * @Date: 2021-09-03 10:05:19
 * @LastEditors: yang chenglin
 * @LastEditTime: 2024-02-26 11:28:43
 */
import { useState } from 'react';
import { Dialog, Button } from '@alifd/next';
import styles from './index.module.scss';

/**
 * @param title 弹窗标题名称
 * @param promptInfo 弹窗提示信息
 * @param flag 显示/隐藏弹窗标识
 * @param showIcon 是否显示圈i小图标 true/false
 * @param cancelHandel 取消方法
 * @param buttonContent 按钮文案
 * @returns 提示信息弹窗
 */
const InfoDialog = (props) => {
  const { title, promptInfo, flag, showIcon, cancelHandel,buttonContent } = props;
  return (
    <div>
      <Dialog
        footer={false}
        title={title}
        shouldUpdatePosition
        visible={flag}
        className={styles.dialog}
        onClose={cancelHandel}
      >
        <div>
          <div className={styles.word}>
            {showIcon && (
              <span className={`iconfont icon-icon4-38 ${styles.icon}`} />
            )}
            {promptInfo}
          </div>
          <div className={styles.btn}>
            <Button
              type="normal"
              className={`cancel-btn ${styles.w88}`}
              onClick={cancelHandel}
            >
              {buttonContent ? buttonContent : '关闭'}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default InfoDialog;
